module.exports = "/images/trigger.svg?b118681c68ca8521e2498679dd236ed7";